import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldCard'])
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldCard'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldCard'])
    },
}